import { ReduxService } from 'dashboard-services/services';

import { companiesMyAccountActions } from 'actions/modules/myAccount';

export const companiesInitialState = {
  addCompanyOpen: false,
  sorting: "asc"
}

export default (state = companiesInitialState, action) => {
  switch (action.type) {
    case companiesMyAccountActions.SET_SORTING:
      return ReduxService.updateObject(state, { sorting: action.value })
    case companiesMyAccountActions.ON_CHANGE: {
      if(state[action.name] !== action.value) {
        return ReduxService.updateObject(state, { [action.name]: action.value })
      }
      return state;
    }
    case companiesMyAccountActions.ON_ADD_COMPANY_MODAL_CHANGE:
      return ReduxService.updateObject(state, { addCompanyOpen: action.value })
    default:
      return state;
  }
}